import * as React from 'react';
import styled from 'styled-components';
import { BorderColor, PastelPrimaryColor, PrimaryColor } from '../styles/global/css/Utils';

const Button = styled.button<{ selected?: boolean }>`
	margin: 0;
	border-radius: 5px;
	background-color: ${p => p.selected ? PastelPrimaryColor : 'unset'};
	display: flex;
	align-items: center;
	gap: 7px;
	padding: 5px 12px;
	border: ${p => p.selected ? 'none' : `1px solid ${BorderColor}`};
	font-weight: 500;
	font-size: 13px;
	color: ${PrimaryColor};
	cursor: pointer;
	&:disabled {
		cursor: not-allowed;
	}
`;

type OutlinedButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	icon?: React.ReactNode
	selected?: boolean
};

export default function OutlinedButton({ icon, selected, children, ...rest }: OutlinedButtonProps): JSX.Element {
	return <Button selected={selected} {...rest}>
		{icon}
		{children}
	</Button>;
}
